(() => {
  function mount(root) {
    if (root.dataset.dpaReady) return;
    const variants = JSON.parse(root.querySelector('[data-arm-variants]').textContent);
    const master = root.querySelector('[data-arm-dpa-master]');
    const controls = [{el:root.querySelector('[data-arm-dpa-colour]'),index:0}, {el:root.querySelector('[data-arm-dpa-connector]'),index:1}, {el:root.querySelector('[data-arm-dpa-size]'),index:2}];
    if (!master || !variants.length || controls.some(c => !c.el)) return;
    root.dataset.dpaReady = 'true';
    function show(variant, history) {
      controls.forEach((c, at) => {
        const matches = variants.filter(v => controls.slice(0, at).every(previous => v.options[previous.index] === variant.options[previous.index]));
        const values = [...new Set(matches.map(v => v.options[c.index]))];
        c.el.replaceChildren(...values.map(value => new Option(value, value, false, value === variant.options[c.index])));
      });
      master.value = variant.id;
      master.dispatchEvent(new Event('change', {bubbles:true}));
      const image = root.querySelector('[data-arm-dpa-image]');
      if (image) { image.hidden = !variant.image; if(variant.image) {image.src=variant.image;image.alt=variant.imageAlt || variant.title;} }
      root.querySelector('[data-arm-dpa-caption]').textContent = variant.title;
      if(history){ const url=new URL(location.href);url.searchParams.set('variant',variant.id);window.history.replaceState({},'',url); }
    }
    controls.forEach((c,at) => c.el.addEventListener('change', () => {
      const matches=variants.filter(v => controls.slice(0,at+1).every(p=>v.options[p.index]===p.el.value));
      const exact=matches.find(v => controls.every(p=>v.options[p.index]===p.el.value));
      const preferred=matches.find(v=>v.options[1]==='MicroLock');
      if(matches.length) show(exact || preferred || matches[0],true);
    }));
    function fromUrl(){ const id=new URL(location.href).searchParams.get('variant');show(variants.find(v=>v.id===id)||variants.find(v=>v.id===master.value)||variants[0],false); }
    window.addEventListener('popstate',fromUrl);
    root.querySelector('[data-arm-dpa-help]').addEventListener('click', event => {
      const wrapper = root.querySelector('[data-arm-enquiry-wrapper]');
      const details = wrapper && wrapper.querySelector('details');
      if (!details) return;
      wrapper.hidden = false;
      details.open = true;
      const variant = variants.find(v => v.id === master.value);
      const message = wrapper.querySelector('textarea');
      if (message) message.value = `${event.currentTarget.dataset.message} ${variant.title} (${variant.sku}).`;
      details.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const field = wrapper.querySelector('input[name="contact[name]"]');
      if (field) field.focus({ preventScroll: true });
    });
    fromUrl();
  }
  const init = () => document.querySelectorAll('[data-arm-dpa]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
